import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms"; import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
;
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { LayoutUtilsService, LoaderService, RequestService } from "src/app/shared";
import { SignalingService } from "src/app/shared/services/signaling.service";
import { CaseService } from "src/app/shared/services/case.service";
import { DocumentDetailedDialogComponent } from "../../documents-dialog/document-detailed-dialog/document-detailed-dialog.component";
import { AddTimelineDialogComponent } from "../add-timeline-dialog/add-timeline-dialog.component";
import { openCenteredPopup, getResponsiveDialogWidth } from "src/app/shared/helpers";
import { MaterialManageDialogComponent } from "../../material-page/material-manage-dialog/material-manage-dialog.component";
import { Subscription } from "rxjs/internal/Subscription";
import { GeocodingService } from "src/app/shared/services/geocoding.service";
import { legacyJapaneseAddressCoordinates } from "src/app/shared/utils/japanese-address";

interface DialogData {
    caseId: string;
    note?: any;
    metadata: any;
    type?: any;
    title: string;
    geolocation: string;
    view?: boolean;
    isTimelinePage?: boolean;
    showTimelineBtn?: boolean;
    isReadOnly?: boolean;
}

enum TypesEnum {
    VIDEO = 'Video',
    AUDIO = 'Audio',
    IMAGE = 'Image',
    FILE = 'File',
    CAMERA = 'Camera',
};

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'YYYY-MM-DD',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-view-timeline-dialog',
    templateUrl: './view-timeline-dialog.component.html',
    styleUrls: ['./view-timeline-dialog.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
    ]
})

export class ViewTimelineDialogComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];

    public title: string = undefined;
    public description: string = undefined;
    public type: string = 'note';
    public form: FormGroup;
    public titleDisplayName: string = undefined;
    // public docs: any = [];
    // public cameras: any = [];
    public noteLocation: string = undefined;
    public investigators: any = [];
    public investigatorGroups: any = [];
    public metadata = new Map();
    public documentsList: any = [];
    public camerasList: any = [];
    public enableSurveillance: boolean = false;

    constructor(public dialogRef: MatDialogRef<ViewTimelineDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private loader: LoaderService, private requestService: RequestService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService, private formBuilder: FormBuilder, private dialog: MatDialog, private signalingService: SignalingService, private caseService: CaseService, private geocodingService: GeocodingService) { }

    ngOnInit(): void {
        // console.log(this.data.note)
        this.subscriptions.push(this.requestService.pageOrganization.subscribe((org) => {
            if (org) {
                const settings = this.requestService.getSettings(org);
                this.enableSurveillance = settings.enableSurveillance || false;
            }
        }));
        this.updateNote();
        this.refreshLegacyJapaneseAddress();

        if (this.data && this.data.type) {
            this.type = this.data.type;
        }

        this.data.metadata.fields.forEach((field: any) => {
            this.metadata.set(field.name, field);
        });

        this.data.title = this.data.note?.person_of_interest ? this.translate.instant('Person of Interest') : this.data.note?.car_of_interest ? this.translate.instant('Car of Interest') : this.data.note?.type == 'annotation' ? this.translate.instant('Annotation') : this.data.note?.type == 'location' ? this.translate.instant('Go to Location') : this.data.note?.type == 'material' ? this.translate.instant('Material') : this.data.note?.type == 'threat' ? this.translate.instant('Dispatched') : this.data.title;

        // console.log(this.metadata, this.data.note)
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    updateNote() {
        if (this.data.note?.document?.type)
            this.titleDisplayName = this.translate.instant(TypesEnum[this.data.note.document.type.toUpperCase()]);

        let investigators = [];
        if (this.data.note?.investigators?.length) {
            this.data.note?.investigators.forEach(i => {
                investigators.push(i.alternative_name || i.name);
            });
        }
        let investigatorGroups = [];
        if (this.data.note?.investigatorgroup?.length) {
            this.data.note?.investigatorgroup.forEach(i => {
                investigatorGroups.push(i.name);
            });
        }
        let title = this.data.note?.name || '';
        if (this.data.note?.type === 'material') {
            if (this.data.note?.documents?.length) {
                title = this.data.note.documents.map(doc => doc.name).join(', ');
            } else {
                title = '';
            }
        }

        this.form = this.formBuilder.group({
            title: [title || ''],
            caseId: [this.data.note?.case?.case_id || ''],
            description: [this.data.note?.description || ''],
            selectedType: [this.data.note?.document?.type || ''],
            document: [''],
            camera: [''],
            documents: [''],
            cameras: [''],
            address: [this.data.note?.location || ''],
            actionDate: [''],
            actionTime: [''],
            interest: [this.data.note?.person_of_interest ? 'person' : 'car'],
            personOfInterestName: [this.data.note?.person_of_interest_name || ''],
            personOfInterestDescription: [this.data.note?.person_of_interest_description || ''],
            personOfInterestDOB: [this.data.note?.person_of_interest_dob ? moment(this.data.note.person_of_interest_dob).format('YYYY-MM-DD') : ''],
            personOfInterestApproximateAge: [this.data.note?.person_of_interest_approximate_age || ''],
            personOfInterestGender: [this.data.note?.person_of_interest_gender || ''],
            personOfInterestGenderOther: [this.data.note?.person_of_interest_gender_other || ''],
            personOfInterestHairColor: [this.data.note?.person_of_interest_hair_color || ''],
            personOfInterestHeight: [this.data.note?.person_of_interest_height || ''],
            personOfInterestDistinguishingFeatures: [this.data.note?.person_of_interest_distinguishing_features || ''],
            personOfInterestWeight: [this.data.note?.person_of_interest_weight || ''],
            personOfInterestEyeColor: [this.data.note?.person_of_interest_eye_color || ''],
            personOfInterestRace: [this.data.note?.person_of_interest_race || ''],
            notes: [this.data.note?.notes || ''],
            plateOfInterest: [this.data.note?.plate_of_interest || ''],
            plateOfInterestDescription: [this.data.note?.car_of_interest_description || ''],
            plateOfInterestIdentifier: [this.data.note?.car_of_interest_identifier || ''],
            carType: [this.data.note?.car_type || ''],
            carMake: [this.data.note?.car_make || ''],
            carModel: [this.data.note?.car_model || ''],
            carColor: [this.data.note?.car_color || ''],
            investigators: [investigators.length ? investigators.join(", ") : ''],
            investigatorGroups: [investigatorGroups.length ? investigatorGroups.join(", ") : ''],
            threat_type: [this.data.note?.threat_type || ''],
            threat_types: [this.getInitialThreatTypesFromNote()],
        });

        if (this.data.note?.action_date) {
            this.form.controls.actionDate.setValue(moment(this.data.note.action_date).format('YYYY-MM-DD'));
            this.form.controls.actionTime.setValue(moment(this.data.note.action_date).format("HH:mm"));
        }

        this.noteLocation = this.data.note?.geolocation;

        if (this.data.note?.document?.type) {
            this.form.controls.selectedType.setValue(this.data.note.document.type);
            this.form.controls.document.setValue(this.data.note.document.name);
            // this.loadDocuments(this.data.note?.document.type);
        }
        else if (this.data.note?.camera?._id) {
            this.form.controls.selectedType.setValue('camera');
            this.form.controls.camera.setValue(this.data.note.camera.name);
            // this.loadCameras(this.data.caseId);
        }
        if (this.data.note?.documents?.length) {
            this.documentsList = this.data.note?.documents;
        }
        if (this.data.note?.cameras?.length) {
            this.camerasList = this.data.note?.cameras;
        }
    }

    /** Re-resolve previously saved comma-separated Japanese addresses for display. */
    private refreshLegacyJapaneseAddress(): void {
        const currentAddress = String(this.form?.controls?.address?.value || '').trim();
        const location = legacyJapaneseAddressCoordinates(currentAddress, this.data.note?.geolocation);
        if (!location) {
            return;
        }

        void this.geocodingService.reverseLookup(location.lat, location.lng, 'ja').then(address => {
            if (address) {
                this.form.controls.address.setValue(address);
            }
        }).catch(() => undefined);
    }

    hasItem(docs: any[] | undefined, type): boolean {
        return !!docs && docs.some(d => d.type === type);
    }

    get threatTypesEnumForDisplay(): any[] {
        const multi = this.metadata.get('threat_types');
        const single = this.metadata.get('threat_type');
        return multi?.enum?.length ? multi.enum : single?.enum || [];
    }

    get threatTypesDisplay(): string {
        const values: string[] = this.form?.controls?.threat_types?.value;
        if (!Array.isArray(values) || !values.length) {
            return '';
        }
        const enumOptions = this.threatTypesEnumForDisplay;
        return values
            .map(v => enumOptions.find(e => e.value === v)?.displayName || v)
            .join(', ');
    }

    private getInitialThreatTypesFromNote(): string[] {
        const n = this.data.note;
        if (!n) {
            return [];
        }
        if (Array.isArray(n.threat_types) && n.threat_types.length) {
            return [...n.threat_types];
        }
        if (n.threat_type) {
            return [n.threat_type];
        }
        return [];
    }
    // private loadDocuments(type: string) {
    //     this.loader.display(true);
    //     this.loadDocumentsPromise(type).then((data: any) => {
    //         this.docs = data.results;
    //         if (this.data.note?.document._id)
    //             this.form.controls.document.setValue(this.data.note?.document._id);
    //     }).finally(() => {
    //         this.loader.display(false);
    //     })
    // }

    // private loadCameras(caseId: string) {
    //     this.loader.display(true);
    //     this.loadCamerasPromise(caseId).then((cameras: any) => {
    //         this.cameras = cameras.results || [];
    //         if (this.data.note?.camera._id)
    //             this.form.controls.camera.setValue(this.data.note?.camera._id);
    //     }).finally(() => {
    //         this.loader.display(false);
    //     })
    // }

    // private loadCamerasPromise(caseId: string): Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         this.requestService.getRecord('', `case/camera/${caseId}/all`, (data, error) => {
    //             if (error) {
    //                 reject(error);
    //             }
    //             if (data) {
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    // private loadDocumentsPromise(type: string): Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         this.requestService.postRequest('doc', 'search', {
    //             order: [{ "field": "createdAt", "order": "desc" }],
    //             fields: ["createdAt", "name", "case", "type", "url"],
    //             term: "",
    //             filter: {
    //                 "$and": [
    //                     { "organizationId._id": { "$in": [this.requestService.orgId] } },
    //                     { "case._id": { "$eq": this.data.caseId } },
    //                     { "type": { "$eq": type } },
    //                 ]
    //             }
    //         }, (data, error) => {
    //             if (error) {
    //                 reject(error);
    //             }
    //             if (data) {
    //                 resolve(data);
    //             }
    //         });
    //     });
    // }

    markerMapSelect(mark: any) {
        this.noteLocation = JSON.stringify(mark);
    }

    // addressPinData(address: any) {
    //     this.form.controls.address.setValue(address);
    // }

    opencameras(cameras, note) {
        if (!cameras?.length) {
            return;
        }
        const caseId = this.data.caseId || note?.case?._id;
        if (cameras.length > 1) {
            if (!caseId || !note?._id) {
                return;
            }
            const url = '/case-note-cameras/' + caseId + '/' + note._id;
            openCenteredPopup(url, this.translate.instant('Camera') + ':' + (note.name || ''));
            return;
        }
        const camera = cameras[0];
        if (!camera?._id) {
            return;
        }
        openCenteredPopup('/camera/' + camera._id, this.translate.instant('Camera') + ':' + (camera.name || ''));
    }
    getIdList(listData) {
        let dataList = [];
        if (listData) {
            for (let itm of listData) {
                dataList.push(itm._id);
            }
        }
        return dataList;
    }
    openDocuments(items: any[], type) {
        if (items.length > 0) {
            let item = items.filter(itm => itm.type == type);
            if (item.length > 1) {
                let title = type + ' Attachments';
                let itm = this.getIdList(item);
                const dialogRef = this.dialog.open(MaterialManageDialogComponent, {
                    autoFocus: false,
                    width: '80vw',
                    disableClose: true,
                    data: {
                        title: title,
                        caseId: this.data.caseId,
                        selectedFiles: itm,
                        editMode: true,
                        type: type || 'Media',
                        metadata: undefined,
                    }
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        // do nothing
                    }
                });
            } else {
                const dialog = this.dialog.open(DocumentDetailedDialogComponent, {
                    autoFocus: false,
                    width: 'fit-content',
                    minWidth: '30vw',
                    disableClose: false,
                    data: {
                        docId: item[0]._id,
                        name: item[0].name,
                        url: item[0].url,
                        type: item[0].type,
                        createdAt: item[0].createdAt,
                        createdName: item[0].createdName,
                    }
                })
            }
        }
    }
    openDocument() {
        const dialog = this.dialog.open(DocumentDetailedDialogComponent, {
            autoFocus: false,
            width: 'fit-content',
            minWidth: '30vw',
            disableClose: false,
            data: {
                docId: this.data.note.document._id,
                name: this.data.note.document.name,
                url: this.data.note.document.url,
                type: this.data.note.document.type,
                createdAt: this.data.note.createdAt,
                createdName: this.data.note.createdName,
            }
        })
    }

    editNote(note: any) {
        this.editTheNote(note);
    }
    editTheNote(note: any) {
        const dialogRef = this.dialog.open(AddTimelineDialogComponent, {
            autoFocus: false,
            width: getResponsiveDialogWidth(),
            data: {
                caseId: this.data.caseId || undefined,
                note: note,
                type: 'note',
                metadata: this.data.metadata,
                subType: note.car_of_interest ? 'carOfInterest' : note.person_of_interest ? 'personOfInterest' : '',
                title: this.translate.instant('Edit')
            }
        });
        this.dialogRef.close({ status: 'edit', note: note });
        // dialogRef.afterClosed().subscribe(result => {
        //     if (result) {
        //         // this.requestService.reloadTimeline.next(true);
        //         if (result.data) {
        //             this.data.note = result.data;
        //             this.updateNote();
        //         } 
        //         else {
        //             this.dialogRef.close();
        //         }
        //     }
        // });
    }
    goTimeline() {
        this.dialogRef.close();
        if (this.data.caseId) {
            // window.open(`/case/${this.data.caseId}/timeline`, "_blank")
            let timelineId = this.data.note?._id;
            openCenteredPopup(`/case/${this.data.caseId}/timeline/${timelineId}`, this.translate.instant('Timeline'));
        }
    }

    resolveThreat() {
        if (!this.data.note?.threat?._id) {
            return;
        }

        this.loader.display(true);

        this.requestService.getRequest(
            'threatsmeta',
            `resolved/${this.data.note.threat._id}`,
            (data, error) => {
                if (data) {
                    this.layoutUtilsService.showNotification(
                        this.translate.instant('updated successfully'),
                        this.translate.instant('Dismiss')
                    );
                    this.requestService.reloadTimeline.next(true);
                    this.dialogRef.close({ data: data.results || data });
                }

                if (error) {
                    this.layoutUtilsService.showNotification(
                        this.translate.instant('An error has occurred. Please try again later.'),
                        this.translate.instant('Dismiss')
                    );
                }

                this.loader.display(false);
            }
        );
    }
}
